import { useState } from 'react';

import { Box, Typography } from '@mui/material';
import { StyledMiniBoxKCPAT, StyledSlider } from 'routes/Main/style';

import { IFormValues } from 'routes/Main/type';
import { Ti18nId } from 'hooks/useI18n';
import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormValues {
  disabled?: boolean;
  onRequired: (id: Ti18nId) => void;
}

const NRSPoint = (props: Props) => {
  const { disabled, setValue, getValues } = props;
  const [painScore, setPainScore] = useState(
    getValues('no3') !== undefined ? getValues('no3') : 0
  );

  return (
    <>
      <SectionTitle title="3. 현재 통증 강도" mt={3} mb={3} />
      <Typography
        sx={{
          fontSize: '12px',
          fontWeight: 500,
          marginBottom: '10px',
          marginLeft: '3px',
        }}
      >
        0에서 10까지의 숫자 중에서 현재 통증이 얼마나 심한지를 잘 나타내는
        숫자에 표시하세요.
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: '24px',
        }}
      >
        <StyledSlider
          disabled={disabled}
          min={0}
          max={10}
          marks={Array(11)
            .fill(0)
            .map((_, i) => {
              return { value: i, label: i };
            })}
          sx={{ width: '800px' }}
          value={painScore}
          defaultValue={painScore}
          onChange={(_, value) => {
            setPainScore(Number(value));
            setValue('no3', value);
          }}
        />
        <Box
          sx={{
            width: '860px',
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '20px',
          }}
        >
          <StyledMiniBoxKCPAT>통증없음</StyledMiniBoxKCPAT>
          <StyledMiniBoxKCPAT>
            상상할 수
            <br />
            없을 정도의
            <br />
            심한 통증
          </StyledMiniBoxKCPAT>
        </Box>
      </Box>
    </>
  );
};

export default NRSPoint;
